export const osStandardFilterFields = [
	'organizationId',
	'id',
	'recipeId',
	'name',
	'takeoffTypeId',
	'measurementTypeId',

	'usageIds',
	'formulaIds',
	'materialTemplateIds',

	'organizationId',
] as const;

export const osDateFilterFields = ['createdAt', 'updatedAt'] as const;

export const osFilterFields = [...osStandardFilterFields, ...osDateFilterFields] as const;

export const filterFields = [...osFilterFields] as const;
